import { render } from "./OurFeatures.vue?vue&type=template&id=4387318f&scoped=true"
const script = {}

import "./OurFeatures.vue?vue&type=style&index=0&id=4387318f&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4387318f"]])

export default __exports__